export default __webpack_public_path__ + "images/person-image.png?2c6c20b5423e04380548f0d247feb0c1";